import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./EditUserInfo.css"; // Move styles here
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay";
// import { getOneUser, editUser } from "../../api/userApi"; // <-- adjust your imports
import { getOneUser, editUser } from "../../services/user.services";
import UserSidebar from "../../../components/userSiderbar/userSidebar";

const initialState = {
    _id: "",
    userName: "",
    email: "",
    contactNumber: "",
    password: "",
    organizationName: "",
    isAdmin: false,
    firstName: "",
    lastName: "",
};

const EditAccInfo = ({ history }) => {
    const [initialStateForm, setInitialStateForm] = useState(initialState);
    const [displayPhone, setDisplayPhone] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userDetailsLoader, setUserDetailsLoader] = useState(false);
    const [error, setError] = useState(null);
    const [successVisible, setSuccessVisible] = useState(false);

    const user = useSelector((state) => state.auth.user);

    const toggleSuccessModal = () => {
        setSuccessVisible(true);
        setTimeout(() => {
            history.goBack(); // using react-router
            setSuccessVisible(false);
        }, 2500);
    };

    const handleFormChange = (name, value) => {
        setInitialStateForm((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        handleFormChange("userId", user._id);
    }, [user._id]);

    // GET ONE USER
    useEffect(() => {
        (async () => {
            try {
                setUserDetailsLoader(true);
                let response = await getOneUser(user._id, user?.token);
                handleFormChange("userId", response.data._id);
                handleFormChange("userName", response.data.userName);
                handleFormChange("firstName", response.data.firstName);
                handleFormChange("lastName", response.data.lastName);
                handleFormChange("email", response.data.email);
                handleFormChange("contactNumber", response.data.contactNumber);
                handleFormChange("password", "");
                handleFormChange("organizationName", response.data.organizationName);
                handleFormChange("isAdmin", false);
            } catch (e) {
                console.log("Err at getOneUser", e);
            } finally {
                setUserDetailsLoader(false);
            }
        })();
    }, [user._id]);

    // Phone formatting
    useEffect(() => {
        let phoneLength = initialStateForm.contactNumber.length;
        let formattedNumber = "";

        if (phoneLength < 4) {
            formattedNumber = initialStateForm.contactNumber;
        } else {
            if (phoneLength > 3 && phoneLength < 7) {
                formattedNumber = `(${initialStateForm.contactNumber
                    .toString()
                    .slice(0, 3)}) ${initialStateForm.contactNumber.toString().slice(3)}`;
            } else {
                formattedNumber = `(${initialStateForm.contactNumber
                    .toString()
                    .slice(0, 3)}) ${initialStateForm.contactNumber
                        .toString()
                        .slice(3, 6)}-${initialStateForm.contactNumber
                            .toString()
                            .slice(6, 10)}`;
            }
        }

        setDisplayPhone(formattedNumber);
    }, [initialStateForm.contactNumber]);

    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleCreate = async () => {
        try {
            if (
                initialStateForm.email.length > 0 &&
                !isValidEmail(initialStateForm.email)
            ) {
                throw new Error("Invalid email format!");
            }

            setLoading(true);
            const payload = {
                userId: initialStateForm.userId,
                userName: initialStateForm.userName,
                email: initialStateForm.email,
                contactNumber: initialStateForm.contactNumber,
                organizationName: initialStateForm.organizationName,
                password: initialStateForm.password,
                isAdmin: false,
            };

            console.log("FINAL CLEAN PAYLOAD:", payload);
            await editUser(payload, user?.token);
            toggleSuccessModal();
        } catch (e) {
            console.log("Error updating user:", e.response?.data || e.message);
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

        useEffect(() => {
        handleFormChange('userName', initialStateForm.firstName + " " + initialStateForm.lastName)
    }, [initialStateForm.firstName, initialStateForm.lastName])

    return (
        <div className="edit-container">
            <UserSidebar />
             <ErrorOverlay
                            onBackdropPress={() => setError(null)}
                            visible={!!error}
                            error={error}
                        />
            <div className="settings-header">
                <h1 className="header-txt-settings" style={{ color: "#1a2a6c" }}>EDIT ACCOUNT INFORMATION</h1>
            </div>

            <div style={{display: 'flex', justifyContent: 'right',marginRight: '40px'}}>
            <div className="containerCreateTeam-accSettings">
                {/* <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Username:</label>
                    <input
                        type="text"
                        className="inputCreateTeam"
                        placeholder="User Name"
                        value={initialStateForm.userName}
                        onChange={(e) => handleFormChange("userName", e.target.value)}
                    />
                </div> */}

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">First Name:</label>
                    <input
                        type="text"
                        className="inputCreateTeam"
                        placeholder="first Name"
                        value={initialStateForm.firstName}
                        onChange={(e) => handleFormChange("firstName", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Last name:</label>
                    <input
                        type="text"
                        className="inputCreateTeam"
                        placeholder="Last Name"
                        value={initialStateForm.lastName}
                        onChange={(e) => handleFormChange("firstName", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Password:</label>
                    <input
                        type="password"
                        placeholder="Password"
                        className="inputCreateTeam"
                        value={initialStateForm.password}
                        onChange={(e) => handleFormChange("password", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Email:</label>
                    <input
                        type="email"
                        className="inputCreateTeam"
                        placeholder="Email"
                        value={initialStateForm.email}
                        onChange={(e) => handleFormChange("email", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Phone:</label>
                    <input
                        type="text"
                        className="inputCreateTeam"
                        placeholder="Contact Number"
                        value={isFocused ? initialStateForm.contactNumber : displayPhone}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onChange={(e) => handleFormChange("contactNumber", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">League/School:</label>
                    <input
                        type="text"
                        className="inputCreateTeam"
                        placeholder="Organization Name"
                        value={initialStateForm.organizationName}
                        onChange={(e) => handleFormChange("organizationName", e.target.value)}
                    />
                </div>


                <div className="btn-row-editUser">
                    <button
                        className="cancel-btn-editUser"
                        onClick={() => history.goBack()}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="save-btn-editUser"
                        onClick={handleCreate}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>
                </div>
            </div>
        </div>
    );
};

export default EditAccInfo;
